import { render } from "./AfspraakMaken.vue?vue&type=template&id=5dcee6c0&scoped=true"
import script from "./AfspraakMaken.vue?vue&type=script&lang=js"
export * from "./AfspraakMaken.vue?vue&type=script&lang=js"

import "./AfspraakMaken.vue?vue&type=style&index=0&id=5dcee6c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcee6c0"]])

export default __exports__